import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c92aae2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "aria-labelledby"]
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-2c92aae2><rect width=\"40\" height=\"40\" rx=\"10\" fill=\"#F9F9F9\" data-v-2c92aae2></rect><g clip-path=\"url(#clip0_203_19)\" data-v-2c92aae2><path opacity=\"0.4\" d=\"M30.1796 24.6875H28.4245V12.1875C28.4245 11.3247 27.7957 10.625 27.0204 10.625H17.1919V15.3125H24.2122V31.3281C24.2122 31.9751 24.6839 32.5 25.2653 32.5H27.3714C27.9528 32.5 28.4245 31.9751 28.4245 31.3281V29.375H30.1796C30.7609 29.375 31.2326 28.8501 31.2326 28.2031V25.8594C31.2326 25.2119 30.7609 24.6875 30.1796 24.6875ZM15.7878 8.67188C15.7878 8.02441 15.3161 7.5 14.7348 7.5H12.6287C12.0473 7.5 11.5756 8.02441 11.5756 8.67188V10.625H9.82051C9.23914 10.625 8.76746 11.1494 8.76746 11.7969V14.1406C8.76746 14.7876 9.23914 15.3125 9.82051 15.3125H11.5756V27.8125C11.5756 28.6753 12.2044 29.375 12.9797 29.375H22.8082V24.6875H15.7878V8.67188Z\" fill=\"#203972\" data-v-2c92aae2></path><path d=\"M15.7878 8.67188C15.7878 8.02441 15.3161 7.5 14.7348 7.5H12.6287C12.0473 7.5 11.5756 8.02441 11.5756 8.67188V10.625H9.82051C9.23914 10.625 8.76746 11.1494 8.76746 11.7969V14.1406C8.76746 14.7876 9.23914 15.3125 9.82051 15.3125H11.5756V27.8125C11.5756 28.6753 12.2044 29.375 12.9797 29.375H22.8082V24.6875H15.7878V8.67188Z\" fill=\"#203972\" data-v-2c92aae2></path></g><defs data-v-2c92aae2><clipPath id=\"clip0_203_19\" data-v-2c92aae2><rect width=\"22.4652\" height=\"25\" fill=\"white\" transform=\"translate(8.76746 7.5)\" data-v-2c92aae2></rect></clipPath></defs></svg>", 1)
const _hoisted_6 = ["id"]
const _hoisted_7 = {
  ref: "refBtnClose",
  "data-bs-dismiss": "modal",
  "aria-label": "Close",
  style: {"cursor":"pointer"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11.8516 8.59375L16.7378 3.70752C17.3374 3.10791 17.3374 2.13574 16.7378 1.53564L15.6519 0.449707C15.0522 -0.149902 14.0801 -0.149902 13.48 0.449707L8.59375 5.33594L3.70752 0.449707C3.10791 -0.149902 2.13574 -0.149902 1.53564 0.449707L0.449707 1.53564C-0.149902 2.13525 -0.149902 3.10742 0.449707 3.70752L5.33594 8.59375L0.449707 13.48C-0.149902 14.0796 -0.149902 15.0518 0.449707 15.6519L1.53564 16.7378C2.13525 17.3374 3.10791 17.3374 3.70752 16.7378L8.59375 11.8516L13.48 16.7378C14.0796 17.3374 15.0522 17.3374 15.6519 16.7378L16.7378 15.6519C17.3374 15.0522 17.3374 14.0801 16.7378 13.48L11.8516 8.59375Z",
    fill: "#B5B5C3"
  })
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "modal-body" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "p-7 pt-0" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-6" }
const _hoisted_15 = {
  key: 0,
  class: "btn w-100 background_btn_1_opct",
  style: {"color":"var(--cor_icones_1)","border-radius":".4rem"},
  type: "button",
  disabled: ""
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_17 = ["for"]
const _hoisted_18 = ["id"]
const _hoisted_19 = { class: "col-6" }
const _hoisted_20 = {
  key: 0,
  class: "btn w-100 background_btn_1",
  style: {"color":"var(--cor_icones_1)","border-radius":".4rem"},
  type: "button",
  disabled: ""
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_22 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CampCropImageLoader = _resolveComponent("CampCropImageLoader")!
  const _component_Cropper = _resolveComponent("Cropper")!
  const _component_CampCropImageRack = _resolveComponent("CampCropImageRack")!
  const _component_CampConstrainProportionDiv = _resolveComponent("CampConstrainProportionDiv")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "refCroppedModal",
    class: "modal fade",
    id: `modal-crop-image_${_ctx.uuidModal}`,
    tabindex: "-1",
    "aria-labelledby": `modal-crop-image-label_${_ctx.uuidModal}`,
    "aria-hidden": "true",
    "data-bs-backdrop": "static",
    "data-bs-keyboard": "false"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("h5", {
            class: "modal-title cor_texto_1",
            style: {"font-size":"1.7rem"},
            id: `modal-crop-image-label_${_ctx.uuidModal}`
          }, "Cortar Imagem", 8, _hoisted_6),
          _createElementVNode("label", _hoisted_7, _hoisted_9, 512)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_CampConstrainProportionDiv, null, {
            default: _withCtx(() => [
              _createVNode(_component_CampCropImageRack, { style: {"position":"absolute"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_CampCropImageLoader, { isLoading: _ctx.editingImgIsLoading }, null, 8, ["isLoading"]),
                  (_ctx.editingImgURL)
                    ? (_openBlock(), _createBlock(_component_Cropper, {
                        key: 0,
                        class: "cropper",
                        src: _ctx.editingImgURL,
                        canvas: { ..._ctx.objCanvas },
                        "image-restriction": "stencil",
                        onChange: _ctx.handleCroppedImgChange
                      }, null, 8, ["src", "canvas", "onChange"]))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: _ctx.CampUploadImgURL,
                        alt: "Selecione Imagem",
                        style: {"width":"100%","height":"100%"}
                      }, null, 8, _hoisted_11))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              (_ctx.editingImgIsLoading)
                ? (_openBlock(), _createElementBlock("button", _hoisted_15, [
                    _hoisted_16,
                    _createTextVNode(" Aguarde... ")
                  ]))
                : (_openBlock(), _createElementBlock("label", {
                    key: 1,
                    for: `modal-crop-image-url_${_ctx.uuidModal}`,
                    class: "btn w-100 background_btn_1_opct",
                    style: {"color":"var(--cor_icones_1)","border-radius":".4rem"}
                  }, " Alterar ", 8, _hoisted_17)),
              _createElementVNode("input", {
                type: "file",
                class: "d-none",
                id: `modal-crop-image-url_${_ctx.uuidModal}`,
                onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleImgFileChange && _ctx.handleImgFileChange(...args)))
              }, null, 40, _hoisted_18)
            ]),
            _createElementVNode("div", _hoisted_19, [
              (_ctx.editingImgIsLoading)
                ? (_openBlock(), _createElementBlock("button", _hoisted_20, [
                    _hoisted_21,
                    _createTextVNode(" Aguarde... ")
                  ]))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleEditionDone && _ctx.handleEditionDone(...args))),
                    type: "button",
                    class: "btn w-100 background_btn_1",
                    style: {"color":"var(--cor_icones_1)","border-radius":".4rem"},
                    disabled: !_ctx.editingImgURL
                  }, " Salvar ", 8, _hoisted_22))
            ])
          ])
        ])
      ])
    ])
  ], 8, _hoisted_1))
}